import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, coachOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17]">
        <div className="text-slate-400 font-mono-stat text-sm uppercase tracking-widest">
          Chargement...
        </div>
      </div>
    );
  }
  if (user === false) {
    // Preserve the requested URL so we can jump back after login (e.g. WhatsApp share link)
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (user.is_pending) return <Navigate to="/pending-approval" replace />;
  if (coachOnly && user.role !== "coach" && user.role !== "admin")
    return <Navigate to="/dashboard" replace />;
  return children;
}
